import { bugsnag } from 'shared/utils/services/bugsnag';
import { IConvertSize } from 'shared/types/ConvertSize';
import { requestService } from 'shared/utils/services/requestService';

const ACCEPTABLE_BRANDS_TO_CONVERT_TO = new Set([
  'acne_studios',
  'adidas',
  'air_jordan',
  'alexander_mcqueen',
  'asics',
  'balenciaga',
  'christian_louboutin',
  'converse',
  'dior',
  'dolce_gabbana',
  'gucci',
  'louis_vuitton',
  'maison_margiela',
  'marni',
  'mcq',
  'mizuno',
  'new_balance',
  'nike',
  'off_white',
  'puma',
  'reebok',
  'rick_owens',
  'vans',
  'versace',
  'yzy',
]);

interface IGetSizeConversion {
  fromBrand?: string;
  fromGender: string;
  fromUnit: string;
  productType: string;
  toBrand?: string;
  toGender: string;
  toUnit: string;
  userSize: string;
}

// TODO: Refactor other places calling this API to reuse this
export const getSizeConversion = async ({
  fromBrand,
  fromGender,
  fromUnit,
  productType,
  toBrand,
  toGender,
  toUnit,
  userSize,
}: IGetSizeConversion) => {
  try {
    const { data: convertedSize }: { data: IConvertSize } = await requestService({
      url: '/web-api/v1/convert_size',
      method: 'post',
      data: JSON.stringify({
        size: String(userSize),
        from_brand: fromBrand || 'default',
        to_brand: ACCEPTABLE_BRANDS_TO_CONVERT_TO.has(toBrand?.toLowerCase())
          ? toBrand?.toLowerCase()
          : 'default',
        from_gender: fromGender?.toUpperCase(),
        to_gender: toGender?.toUpperCase(),
        from_unit: fromUnit?.toUpperCase(),
        to_unit: toUnit?.toUpperCase(),
        product_type: productType?.toUpperCase(),
      }),
    });

    return convertedSize;
  } catch (error) {
    bugsnag(error, { context: 'Size conversion request fail' });
  }
};
